import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { BookOpen, ExternalLink, Calendar, Users, Award } from 'lucide-react';

const ResearchSection = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');

  const researchPapers = [
    {
      title: "Metabolic health and sleep quality in adults at risk for Type 2 Diabetes using the Fos Biomedical Non-Transdermal Patch System via photo-biomodulation: A randomized, placebo-controlled crossover trial",
      authors: "Njike VY, Ayettey RG, Treu JA, Comerford BP, Onuigbo M",
      journal: "Contemp Clin Trials Commun",
      year: "2025",
      pubmed: "40115254",
      doi: "10.1016/j.conctc.2025.101448",
      category: "clinical",
      abstract: "Background: The impact of the Fos Biomedical non-transdermal patch system (NTPS) that stimulates the skin with low light levels to generate photo-biomodulation (PBM) effects on cardio-metabolic health and sleep quality is unclear. We examined the impact of FBPS compared with placebo on cardio-metabolic risk and sleep quality in persons at risk for type 2 diabetes mellitus (T2DM)."
    },
    {
      title: "Chronic treatment with photobiomodulation decreases blood pressure and improves endothelial function in ovariectomized rats",
      authors: "Nayara Formenton da Silva, Luis Henrique Oliveira de Moraes, Camila Pereira Sabadini, Rita Cristina Cotta Alcântara, Patricia Corrêa Dias, Gerson Jhonatan Rodrigues",
      journal: "Lasers Med Sci",
      year: "2025",
      pubmed: "40100331",
      doi: "10.1007/s10103-025-04404-z",
      category: "cardiovascular",
      abstract: "Menopause is a natural phase, related to the aging reproductive female, characterized by decreased production of hormones steroids, mainly estrogen, involved in multiple physiological process, including cardiovascular function. The objective of this work was to evaluate the in vivo effects of photobiomodularion on cardiovascular parameters in ovariectomy-induced menopause in female rats."
    },
    {
      title: "Photobiomodulation and Physical Exercise Modulate of Cell Survival Proteins in the Skeletal Muscle of Rats with Heart Failure and Diabetes Mellitus",
      authors: "Alan Christhian Bahr, Naira Bohrer Scherer, Elizama de Gregório, Lucas Kieling, Alexandre Luz de Castro, Alex Sander da Rosa Araujo, Patrick Türck, Pedro Dal Lago",
      journal: "Photobiomodul Photomed Laser Surg",
      year: "2024",
      pubmed: "39441652",
      doi: "10.1089/photob.2024.0073",
      category: "heart-failure",
      abstract: "Heart failure (HF) and type 2 diabetes mellitus (DM2) are global health problems that often lead to muscle atrophy. Physical exercise associated with photobiomodulation (PBM) seems promising to attenuate the skeletal muscle changes caused by HF and DM2, due to its direct effects on mitochondria."
    },
    {
      title: "Inflammatory markers, oxidative stress, and mitochondrial dynamics: Repercussions on coronary artery disease in diabetes",
      authors: "Tatmatsu-Rocha JC, Mendes-Costa LS",
      journal: "World J Diabetes",
      year: "2024",
      pubmed: "39280176",
      doi: "10.4239/wjd.v15.i9.1853",
      category: "cardiovascular",
      abstract: "Photobiomodulation (PBM) has recently been considered a possible therapeutic agent for cardiovascular diseases due to its effects on mitochondrial dynamics and oxidative stress. Therapies such as PBM that act on pro-inflammatory mediators and mitochondrial modulation could benefit those with cardiovascular diseases."
    },
    {
      title: "Examining the impact of varying low-level laser dose on cardiac failure",
      authors: "Luiz Antonio E, de Oliveira HA, Albuquerque-Pontes GM, Teixeira ILA, Yoshizaki AP, Dos Santos LFN, Leal-Junior ECP, Tucci PJF, Serra AJ",
      journal: "Photochem Photobiol",
      year: "2024",
      pubmed: "39126163",
      doi: "10.1111/php.14012",
      category: "heart-failure",
      abstract: "Low-level laser therapy (LLLT) has been targeted as a promising tool that can mitigate post-infarction cardiac remodeling. This study evaluated effects of repeated LLLT applications with different energies delivered to the infarcted myocardium. LLLT on 10J and 20J had a similar action in attenuating pulmonary congestion and myocardial fibrosis."
    },
    {
      title: "Photobiomodulation Inhibits Ischemia-Induced Brain Endothelial Senescence via Endothelial Nitric Oxide Synthase",
      authors: "Feng Y, Huang Z, Ma X, Zong X, Tesic V, Ding B, Wu CY, Lee RH, Zhang Q",
      journal: "Antioxidants (Basel)",
      year: "2024",
      pubmed: "38929072",
      doi: "10.3390/antiox13060633",
      category: "vascular",
      abstract: "Recent research suggests that photobiomodulation therapy (PBMT) positively impacts the vascular function associated with various cerebrovascular diseases. We demonstrated that treatment with PBMT (808 nm, 350 mW/cm2, 2 min/day) for 7 days significantly reduced PT-stroke-induced vascular permeability."
    },
    {
      title: "Study and optimization of the photobiomodulation effects induced on mitochondrial metabolic activity of human cardiomyocytes for different radiometric and spectral conditions",
      authors: "Jaroslava Joniová, Emmanuel Gerelli, Georges Wagnières",
      journal: "Life Sci",
      year: "2024",
      pubmed: "38823506",
      doi: "10.1016/j.lfs.2024.122760",
      category: "mitochondrial",
      abstract: "Photobiomodulation (PBM) represents a promising and powerful approach for non-invasive therapeutic interventions. Our study delves into a multitude of PBM illumination parameters while assessing the PBM's effects on the basis of endpoints reflecting the mitochondrial metabolism of human cardiac myocytes (HCM), that are known for their high mitochondrial density."
    },
    {
      title: "Evaluation of Photobiomodulation on myocardial function of Patients with Advanced Ischemic Cardiomyopathy, A Case Series",
      authors: "Razzaghi M, Sheibani F, Barati M, Alirezaei T, Razzaghi Z, Hajimoradi M, Najafi F, Hajimoradi B",
      journal: "Photodiagnosis Photodyn Ther",
      year: "2024",
      pubmed: "38685548",
      doi: "10.1016/j.pdpdt.2024.104092",
      category: "clinical",
      abstract: "Heart failure is a growing cardiovascular disease burden with high mortality rates, primarily attributed to myocardial ischemia. A non-randomized case series study involving 10 advanced heart failure patients was conducted. Patients received 15 sessions of transcutaneous and intravenous Photobiomodulation therapy using low-level red (658 nm) and infrared lasers (810 nm)."
    },
    {
      title: "Photobiomodulation for Blood Pressure and Heart Rate Reduction in Mastectomized Women on Hormone Blockers: A Randomized Controlled Trial",
      authors: "Pacheco JA, Molena KF, Veiga EV",
      journal: "Photobiomodul Photomed Laser Surg",
      year: "2024",
      pubmed: "38530295",
      doi: "10.1089/photob.2023.0136",
      category: "clinical",
      abstract: "To assess the impact of intravascular laser irradiation of blood (ILIB) on the primitive carotid artery (PCA) hemodynamic variables, specifically blood pressure (BP) and heart rate (HR), in mastectomized patients undergoing hormone blocker treatments. ILIB therapy applied to the PCA induces a reduction in BP and, more notably, HR in mastectomized women."
    },
    {
      title: "Long-term effects of photobiomodulation therapy on blood pressure in obese rats induced by a high-fat diet",
      authors: "Oishi JC, de Moraes LHO, Filho JCC, de Moraes TF, Terroni B, de Castro CA, Almeida-Lopes L, Rodrigues GJ",
      journal: "Lasers Med Sci",
      year: "2024",
      pubmed: "38165554",
      doi: "10.1007/s10103-023-03950-8",
      category: "cardiovascular",
      abstract: "The main cardiovascular disease risk associated with obesity is hypertension. Our results indicate that PBM carried out 3 days a week was able to prevent the increase in blood pressure induced by a high-fat diet, restore nitric oxide levels, decrease lipoperoxidation, and improve endothelial function."
    },
    {
      title: "Transcranial photobiomodulation therapy associated with cardiorespiratory rehabilitation in spastic subjects",
      authors: "Pinto AP, Lemos SL, de Almeida Fagundes A, das Neves MF, Rodrigo Álvaro Brandão Lopes-Martins B, Lima FPS, Lima MO",
      journal: "Lasers Med Sci",
      year: "2023",
      pubmed: "37910318",
      doi: "10.1007/s10103-023-03922-y",
      category: "rehabilitation",
      abstract: "The objective of this study was to evaluate the effects of cardiorespiratory rehabilitation (CR) and transcranial photobiomodulation (tPBM) on exercise tolerance (ET), heart rate variability (HRV), and peripheral muscle activity in individuals with spasticity."
    },
    {
      title: "Effects of photobiomodulation and caffeine treatment on acute kidney injury in a hypoxic ischemic neonatal rat model",
      authors: "Groves AM, Johnston CJ, Beutner G, Dahlstrom JE, Koina M, O'Reilly M, Marples B, Porter G, Brophy PD, Kent AL",
      journal: "Physiol Rep",
      year: "2023",
      pubmed: "37549967",
      doi: "10.14814/phy2.15773",
      category: "neonatal",
      abstract: "Hypoxic ischemic encephalopathy (HIE) occurs in 2-5/1000 births, with acute kidney injury (AKI) occurring in 40%. Caffeine, an adenosine receptor antagonist, and photobiomodulation (PBM), working on cytochrome c oxidase, are potential treatments for AKI."
    },
    {
      title: "Exploring the Potential of Energy-Based Therapeutics (Photobiomodulation/Low-Level Laser Light Therapy) in Cardiovascular Disorders: A Review and Perspective",
      authors: "Ganipineni VDP, Gutlapalli SD, Ajay Sai Krishna Kumar I, Monica P, Vagdevi M, Samuel Sowrab T",
      journal: "Cureus",
      year: "2023",
      pubmed: "37214067",
      doi: "10.7759/cureus.37880",
      category: "review",
      abstract: "Based on the review of the literature, this article examines the potential therapeutic benefits of photobiomodulation therapy (PBMT) or low-level laser therapy (LLLT) for the treatment of cardiovascular disorders. The studies suggest that PBMT and LLLT have potential therapeutic benefits for the treatment of cardiovascular diseases."
    },
    {
      title: "Pulsed Laser Acupuncture in the Treatment of Pain and Heart Rate Variability in Fibromyalgia Patients: A Pilot Randomized Clinical Trial",
      authors: "Érika Almeida Boggiss, Rhaynara Coelho Rosário, Rosana Aparecida de Lima, Paula Aparecida Silva, Rosa Maria Moreira, Karol Priscila da Silva, Caroline Lima de Farias, Vanessa de Queiroz Dos Santos, Rodrigo Polaquini Simões, Adriana Teresa Silva Santos, Andréia Maria Silva Vilela Terra",
      journal: "J Lasers Med Sci",
      year: "2023",
      pubmed: "37041781",
      doi: "10.34172/jlms.2022.53",
      category: "clinical",
      abstract: "Laser acupuncture (LA) is a medically approved treatment for chronic pain, especially fibromyalgia. This study aimed to evaluate whether an individualized intervention protocol applying pulsed LA would provide benefits related to pain symptoms and cardiac autonomic modulation in patients with fibromyalgia."
    },
    {
      title: "Photobiomodulation therapy mitigates cardiovascular aging and improves survival",
      authors: "Syed SB, Ahmet I, Chakir K, Morrell CH, Arany PR, Lakatta EG",
      journal: "GeroScience",
      year: "2023",
      pubmed: "36746800",
      doi: "10.1007/s11357-023-00729-5",
      category: "aging",
      abstract: "Photobiomodulation (PBM) therapy, a form of low-dose light therapy, has been noted to be effective in several age-associated chronic diseases such as hypertension and atherosclerosis. Here, we examined the effects of PBM therapy on age-associated cardiovascular changes in a mouse model of accelerated cardiac aging."
    }
  ];

  const categories = [
    { id: 'all', name: 'All Research', count: researchPapers.length },
    { id: 'clinical', name: 'Clinical Trials', count: researchPapers.filter(p => p.category === 'clinical').length },
    { id: 'cardiovascular', name: 'Cardiovascular', count: researchPapers.filter(p => p.category === 'cardiovascular').length },
    { id: 'heart-failure', name: 'Heart Failure', count: researchPapers.filter(p => p.category === 'heart-failure').length },
    { id: 'mitochondrial', name: 'Mitochondrial', count: researchPapers.filter(p => p.category === 'mitochondrial').length },
    { id: 'vascular', name: 'Vascular Function', count: researchPapers.filter(p => p.category === 'vascular').length }
  ];

  const filteredPapers = selectedCategory === 'all' 
    ? researchPapers 
    : researchPapers.filter(paper => paper.category === selectedCategory);

  const fadeInUp = {
    initial: { opacity: 0, y: 60 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.6, ease: "easeOut" }
  };

  return (
    <section id="research" className="py-20 bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div 
          className="text-center mb-16"
          {...fadeInUp}
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            <span className="bg-gradient-to-r from-teal-400 to-primary-400 bg-clip-text text-transparent">
              Cardiac Photobiomodulation Research
            </span>
          </h2>
          <p className="text-xl text-gray-300 max-w-4xl mx-auto">
            Comprehensive collection of peer-reviewed research demonstrating the efficacy and 
            mechanisms of photobiomodulation therapy in cardiovascular health and optimization.
          </p>
        </motion.div>

        {/* Research Statistics */}
        <motion.div
          className="grid md:grid-cols-3 gap-8 mb-16"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <div className="bg-gray-800/50 backdrop-blur-sm rounded-2xl p-8 border border-gray-700 text-center">
            <div className="w-16 h-16 bg-gradient-to-r from-teal-500 to-teal-600 rounded-xl flex items-center justify-center mx-auto mb-4">
              <BookOpen className="w-8 h-8 text-white" />
            </div>
            <h3 className="text-3xl font-bold text-teal-400 mb-2">{researchPapers.length}</h3>
            <p className="text-gray-300">Published Studies</p>
          </div>
          
          <div className="bg-gray-800/50 backdrop-blur-sm rounded-2xl p-8 border border-gray-700 text-center">
            <div className="w-16 h-16 bg-gradient-to-r from-primary-500 to-cardio-500 rounded-xl flex items-center justify-center mx-auto mb-4">
              <Users className="w-8 h-8 text-white" />
            </div>
            <h3 className="text-3xl font-bold text-primary-400 mb-2">2023-2025</h3>
            <p className="text-gray-300">Research Timeframe</p>
          </div>
          
          <div className="bg-gray-800/50 backdrop-blur-sm rounded-2xl p-8 border border-gray-700 text-center">
            <div className="w-16 h-16 bg-gradient-to-r from-performance-500 to-teal-500 rounded-xl flex items-center justify-center mx-auto mb-4">
              <Award className="w-8 h-8 text-white" />
            </div>
            <h3 className="text-3xl font-bold text-performance-400 mb-2">Global</h3>
            <p className="text-gray-300">Research Network</p>
          </div>
        </motion.div>

        {/* Category Filter */}
        <motion.div
          className="flex flex-wrap justify-center gap-4 mb-12"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          {categories.map((category) => (
            <button
              key={category.id}
              onClick={() => setSelectedCategory(category.id)}
              className={`px-6 py-3 rounded-lg font-semibold transition-all duration-300 ${
                selectedCategory === category.id
                  ? 'bg-gradient-to-r from-teal-600 to-cyan-600 text-white'
                  : 'bg-gray-800 text-gray-300 hover:bg-gray-700'
              }`}
            >
              {category.name} ({category.count})
            </button>
          ))}
        </motion.div>

        {/* Research Papers */}
        <div className="space-y-8">
          {filteredPapers.map((paper, index) => (
            <motion.div
              key={index}
              className="bg-gray-800/50 backdrop-blur-sm rounded-2xl p-8 border border-gray-700 hover:border-teal-500/50 transition-all duration-300"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1, duration: 0.6 }}
              viewport={{ once: true }}
            >
              <div className="flex flex-col lg:flex-row lg:items-start gap-6">
                <div className="flex-1">
                  <div className="flex items-start justify-between mb-4">
                    <h3 className="text-xl font-bold text-white leading-tight hover:text-teal-400 transition-colors duration-300">
                      {paper.title}
                    </h3>
                    <div className="flex items-center space-x-2 ml-4">
                      <div className="bg-teal-500/20 text-teal-400 px-3 py-1 rounded-full text-xs font-medium">
                        {paper.year}
                      </div>
                    </div>
                  </div>
                  
                  <p className="text-gray-300 text-sm mb-3 leading-relaxed">
                    <span className="font-semibold">Authors:</span> {paper.authors}
                  </p>
                  
                  <p className="text-primary-400 text-sm font-semibold mb-4">
                    {paper.journal}
                  </p>
                  
                  <p className="text-gray-400 text-sm leading-relaxed mb-6">
                    {paper.abstract}
                  </p>
                  
                  <div className="flex flex-wrap items-center gap-4">
                    <a
                      href={`https://pubmed.ncbi.nlm.nih.gov/${paper.pubmed}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center space-x-2 bg-gradient-to-r from-teal-600 to-cyan-600 hover:from-teal-500 hover:to-teal-600 px-4 py-2 rounded-lg text-white text-sm font-semibold transition-all duration-300"
                    >
                      <span>View on PubMed</span>
                      <ExternalLink className="w-4 h-4" />
                    </a>
                    
                    <div className="text-xs text-gray-500">
                      DOI: {paper.doi}
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Research Summary */}
        <motion.div
          className="mt-16 bg-gradient-to-r from-teal-900/20 to-gray-800/50 backdrop-blur-sm rounded-3xl p-8 border border-teal-500/30"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <div className="text-center">
            <h3 className="text-2xl font-bold text-teal-400 mb-4">
              Evidence-Based Cardiovascular Optimization
            </h3>
            <p className="text-gray-300 leading-relaxed max-w-4xl mx-auto">
              This comprehensive research collection demonstrates the robust scientific foundation 
              underlying photobiomodulation therapy for cardiovascular health. Studies span from 
              basic mitochondrial mechanisms to clinical applications, establishing photobiomodulation 
              as a evidence-based therapeutic modality for cardiac optimization, blood pressure 
              reduction, endothelial function improvement, and overall cardiovascular health enhancement.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default ResearchSection;